<app-stuck-treads-checker-settings-form [settings]="settings"></app-stuck-treads-checker-settings-form>
<div class="dialog-footer">
    <mat-dialog-actions>
        <button mat-flat-button color="primary" style="width: 100%" (click)="save()" [disabled]="isFormInvalid">Save
            Settings</button>
    </mat-dialog-actions>
</div>
